export default __webpack_public_path__ + "static/media/logo-feedback.279b4081.svg";